import $http from '@Config/axios';

const prefix = 'box';
const sufix = 'anotacoes';

export const AnotacaoPresenter = {
	getNote: box_id => $http.get(`${prefix}/${box_id}/${sufix}`),
	insertNote: (box_id, anotacao) => $http.post(`${prefix}/${box_id}/${sufix}`, { anotacao }),
	updateNote: (box_id, anotacao, anotacao_antiga) => $http.put(`${prefix}/${box_id}/${sufix}`, anotacao, anotacao_antiga)
};
